import ApiService from "@/core/services/api.service";

// action types
export const FETCH_TRANSACTIONS = "fetchTransactions";

// mutation types
export const SET_TRANSACTIONS = "setTransactions";
export const SET_TRANSACTIONS_PAGINATION = "setTransactionsPagination";
export const SET_TRANSACTION = "setTransaction";

const state = {
  transactions: [],
  transactionsUser: [],
  transactionsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  transaction: {},
  transactionRelationTypes: {
    1: "دستی",
    2: "پرداخت",
    3: "پخش",
    4: "فضای ابری"
  }
};

const getters = {
  transactions(state) {
    return state.transactions;
  },
  transactionsUser(state) {
    return state.transactionsUser;
  },

  transactionsPagination(state) {
    return state.transactionsPagination;
  },

  transaction(state) {
    return state.transaction;
  },

  transactionRelationTypes(state) {
    return state.transactionRelationTypes;
  }
};

const actions = {
  [FETCH_TRANSACTIONS](context, userId = null) {
    return new Promise((resolve, reject) => {
      let params = {
        page: context.state.transactionsPagination.currentPage
      };

      if (userId) {
        params.user = userId;
      }

      ApiService.query("transactions", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_TRANSACTIONS, data.data);
          context.commit(SET_TRANSACTIONS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_TRANSACTIONS](state, data) {
    state.transactions = data;
  },
  [SET_TRANSACTIONS_PAGINATION](state, data) {
    state.transactionsPagination = data;
  },
  [SET_TRANSACTION](state, transaction) {
    state.transaction = transaction;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
